import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "../Home/Footers";
import Header from "../Home/Header";
import FemaleLogo from "../Courses/FemaleLogo.jpg";
import MaleLogo from "../Courses/MaleLogo.jpg";
import AxiosInstance from "../Home/AxiosInstance";
import "../Courses/Profiles.css";
import "../Home/publicPages.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function DetailsOfUser() {
  const { userId } = useParams();

  const [profile, setProfile] = useState(null);
  const [educations, setEducations] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [courses, setCourses] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Fetch main profile
        const profileRes = await AxiosInstance.get(
          `companies/user/details/${userId}`
        );
        setProfile(profileRes.data);

        // Helper to fetch data with 404 fallback
        const tryFetch = async (url) => {
          try {
            const res = await AxiosInstance.get(url);
            return res.data;
          } catch (err) {
            if (err.response?.status === 404) {
              return []; // Return empty if not found
            } else {
              console.warn(`Error fetching ${url}:`, err.message);
              return [];
            }
          }
        };

        // Fetch remaining data
        const [
          educationRes,
          certRes,
          achieveRes,
          expRes,
          courseRes,
          socialRes,
        ] = await Promise.all([
          tryFetch(`companies/user/educations/${userId}`),
          tryFetch(`companies/user/certifications/${userId}`),
          tryFetch(`companies/user/achievements/${userId}`),
          tryFetch(`companies/work-experiences/${userId}/`),
          tryFetch(`companies/user/courses/${userId}/`),
          tryFetch(`companies/user/social_link/${userId}`),
        ]);

        setEducations(educationRes);
        setCertifications(certRes);
        setAchievements(achieveRes);
        setExperiences(expRes);
        setCourses(courseRes);
        setSocialLinks(socialRes);
      } catch (err) {
        console.error("Failed to load user profile:", err);
        setError("User not found.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  if (loading) return <p className="text-center mt-4">Loading...</p>;
  if (error) return <p className="text-danger text-center mt-4">{error}</p>;
  if (!profile) return null;

  const fullName = profile.alias_name?.trim()
    ? profile.alias_name
    : `${profile.first_name} ${profile.last_name}`;

  const imagePath = profile.image_path
    ? `${AxiosInstance.defaults.baseURL}media/${profile.image_path.replace(
        /\\/g,
        "/"
      )}`
    : profile.gender?.toLowerCase() === "male"
    ? MaleLogo
    : FemaleLogo;

  return (
    <div className="CompanyPage" style={{ backgroundColor: "#f8f9fa" }}>
      <Header />
      <div className="container1">
        <div className="content py-4">
          <div className="navigation-button-container mb-3">
            <nav className="als-breadcrumb als-breadcrumb-light" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span className="als-breadcrumb-sep" aria-hidden="true">
                ›
              </span>
              <span aria-current="page">{fullName}</span>
            </nav>
          </div>

          <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
            <div className="flex-grow-1 me-3">
              <h1>{fullName}</h1>
              <div className="mt-4">
                <h5>About:</h5>
                {profile.about ? (
                  profile.about
                    .split("\n")
                    .map((line, index) => <p key={index}>{line.trim()}</p>)
                ) : (
                  <p>No description provided.</p>
                )}

                <h5>Educations:</h5>
                {educations.length > 0 ? (
                  <ul>
                    {educations.map((edu) => (
                      <li key={edu.user_education_id}>
                        {edu.education?.qualification || "N/A"} (
                        {edu.specialization || "N/A"}) –{" "}
                        {edu.college_name || "N/A"}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No education records found.</p>
                )}

                <h5>Work Experiences:</h5>
                {experiences.length > 0 ? (
                  <ul>
                    {experiences.map((exp) => (
                      <li key={exp.experience_id}>
                        {exp.company_name} ({exp.role?.role || "N/A"}) –{" "}
                        {exp.experience || "N/A"}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No work experience records found.</p>
                )}

                <h5>Courses:</h5>
                {courses.length > 0 ? (
                  <ul>
                    {courses.map((course) => (
                      <li key={course.course_material_id}>
                        {course.course?.course_name || "Unnamed Course"}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No courses found.</p>
                )}

                <h5>Certifications:</h5>
                {certifications.length > 0 ? (
                  <ul>
                    {certifications.map((cert) => (
                      <li key={cert.user_certification_id}>
                        {cert.certification_name} – {cert.issue_authority}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No certifications found.</p>
                )}

                <h5>Achievements:</h5>
                {achievements.length > 0 ? (
                  <ul>
                    {achievements.map((ach) => (
                      <li key={ach.achievement_id}>{ach.title}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No achievements found.</p>
                )}

                <h5>Social Links:</h5>
                {socialLinks.length > 0 ? (
                  <ul>
                    {socialLinks.map((link) => (
                      <li key={link.social_link_id}>
                        <a href={link.url} target="_blank" rel="noreferrer">
                          {link.platform}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No social links found.</p>
                )}
              </div>
            </div>

            <div
              className="profile-image-container mb-3"
              style={{ minWidth: "180px", textAlign: "center" }}
            >
              <img src={imagePath} alt="Profile" className="profile-image" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
